<template>
  <div class="agent">
    <div class="alert alert-success" role="alert">
        <strong><span class="alert-heading">Las APIs V1 sólo tendrán soporte hasta 28-02-2022 y se darán de baja el 30-06-2022, no aplica para API V1 de CRM</span></strong> <br>
        <span>En el siguiente enlace se encuentra la tabla de equivalencias de APIs versión 1.0 y versión 2.0 <a href="https://docs.google.com/spreadsheets/d/13nSRv1WXPJ4IUPdOmYXnKfoDOTpv4zse/edit#gid=727860265" class="alert-link" target="_blank">Click aquí!</a></span>
        <p class="mb-0">Ahora está disponible una versión mejorada de las APIs de Wolkvox - Versión 2.0, con más estandarización. <a href="https://www.wolkvox.com/apis-v2/" class="alert-link" target="_blank">Ver más...</a></p>
    </div>
    <iframe src="https://wolkvox.com/api-agentes.php" frameborder="0" style="width:100%;height: 100vh"></iframe>
  </div>
</template>

<script>
export default {
  name: "Agent"
}
</script>

<style>
  .agent iframe{
    margin-top: 40px;
  }
</style>